export * from './multiple-form-image/multiple-form-image.component';